import { createFileRoute } from '@tanstack/react-router';

/**
 * Order edit route. The editor is being introduced incrementally, but the
 * route must still participate in the permission tree so deep links cannot
 * bypass the catalog contract.
 */
export const Route = createFileRoute('/orders/$orderId/edit')({
  staticData: { permission: 'orders.edit' },
  component: OrderEditRoute,
});

function OrderEditRoute() {
  return null;
}
